import { connect } from 'react-redux';
import { showBanner } from 'common/ducks/banner';
import Referral from 'marketing/components/referral';

export default connect(() => ({}), { showBanner })(Referral);



// WEBPACK FOOTER //
// ./marketing/containers/referral.js